<template>
  <div class="user-agreement">
    <div
      class="user-agreement-content"
      v-if="
        serviceType == 'FL10000001' ||
          serviceType == 'FL90000001' ||
          serviceType == 'FLA0000001'
      "
    >
      <p>尊敬的客户：</p>
      <p class="text-offset-0">
        为了便于您能更好地享受我公司为您提供的保险车辆非事故道路救援服务，特将服务有关注意事项告知如下：
      </p>
      <p class="text-offset-1">一、服务范围</p>
      <p class="text-offset-2">
        1.在本公司投保商业险，且在保险责任期间内的9座以下（含9座）家庭自用和非营业用客车（具体以保单内容为准），提供搭电、更换轮胎和故障拖车等非事故道救援服务。
      </p>
      <p class="text-offset-2">
        2.救援过程中产生的材料费、过路过桥费等不在免费范围内，需要您自理。
      </p>
      <p class="text-offset-1">二、服务规则</p>
      <p class="text-offset-2">
        1.申请人有义务为救援创造有利条件，并积极配合，否则无法提供服务。
      </p>
      <p class="text-offset-2">
        2.本公司和施救方对被救援车辆车内物品不负保管责任，因救援导致的不可避免的车辆损失，本公司和施救方不负责维修和赔偿。
      </p>
      <p class="text-offset-2">
        3.免费拖车服务以就近送修为原则，最远不超过50公里，同一车辆每一个自然日内最多只能提供两次服务（其中拖车最多只能提供一次）。
      </p>
      <p class="text-offset-2">
        4.车辆已经在汽车修理厂维修的，我司不提供免费救援服务，所有免费拖车服务的终点必须为汽车修理厂或者是就近的加油、加气、充电站，原则上不得是其它地方（特列情况除外）。
      </p>
      <p class="text-offset-1">三、其它</p>
      <p class="text-offset-2">
        1.服务发起后，请您在现场耐心等待，到达时间以救援技师真正的到达时间为准。
      </p>
      <p class="text-offset-2">
        2.特殊情况下，本公司可能无法提供服务，包括交通管理部门或道路管理机构不允许社会救援车辆实施救援的高速公路、隧道、大桥、高架道路、匝道等路段，施救车辆不能达到的或不能通行的区域。
      </p>
      <p class="text-offset-2">
        3.未经我公司正式授权的推荐修理均为救援技师个人行为，我公司不负责提供服务品质和维修质量的保障。
      </p>
      <p class="text-offset-2">
        4.在法律许可范围内，本公司保留对此项服务的解释权。
      </p>
      <p class="text-offset-1">特此函告。</p>
    </div>

    <div
      class="user-agreement-content"
      v-if="serviceType == 'FL70000001'"
    >
      <p>尊敬的客户：</p>
      <p class="text-offset-0">
        感谢您选择我公司委托的第三方公司为您提供被保险车辆代为驾驶服务。为了保护您的合法权益，特将服务有关注意事项告知如下，请您仔细阅读。如有任何疑问可向我公司客服进行咨询。
      </p>
      <p class="text-offset-1">一、服务范围</p>
      <p class="text-offset-2">
        1.在本公司投保代为驾驶服务特约条款的被保险车辆，且在保险责任期间内的七座以下（含七座）家庭自用和非营业用客车，提供被保险人或其允许的驾驶人因饮酒、服用药物等原因无法驾驶或存在重大安全驾驶隐患时提供单程30公里以内的短途代驾服务（具体服务车型和服务里程以保单内容为准）。
      </p>
      <p class="text-offset-2">
        2.被保险机动车代为驾驶服务由客户申请，我司委托第三方公司提供代驾服务。代为驾驶服务区域为我司第三方服务商可提供服务范围，部分较偏远地区无法提供代驾服务。
      </p>
      <p class="text-offset-2">
        3.服务过程中产生的过路过桥费等不在免费范围内，需要您自理。
      </p>
      <p class="text-offset-2">
        4.在法律许可范围内，本公司保留对此项服务的解释权。
      </p>
      <p class="text-offset-1">特此函告。</p>
    </div>

    <div
      class="user-agreement-content"
      v-if="serviceType == 'FL60000001'"
    >
      <p>尊敬的客户：</p>
      <p class="text-offset-0">
        感谢您选择我公司委托的第三方公司为您提供保险车辆代为送检服务。为了保护您的合法权益，特将服务有关注意事项告知如下，请您仔细阅读。如有任何疑问可向我公司客服进行咨询。
      </p>
      <p class="text-offset-1">一、服务范围</p>
      <p class="text-offset-2">
        1.在本公司投保代为送检服务特约条款，且在保险责任期间内的7座以下（含7座）家庭自用和非营业用客车（具体以保单内容为准），提供车辆送检服务。
      </p>
      <p class="text-offset-2">
        2.根据《中华人民共和国道路交通安全法实施条例》，被保险机动车需由机动车安全技术检验机构实施安全技术检验时，由客户申请，我司委托第三方公司代替车辆所有人进行车辆送检。
      </p>
      <p class="text-offset-1">二、服务规则</p>
      <p class="text-offset-2">
        1.服务车辆需申请人自行在检验前处理完毕车辆交通违法情况，我司不负责为驾驶人代为处理交通违法事项。
      </p>
      <p class="text-offset-2">
        2.因被保险人自身车辆问题（包含交通违法未处理）导致年检无法通过，后续服务及费用由申请人自行承担。
      </p>
      <p class="text-offset-2">
        3.代办验车涉及的车辆年检费用、因检测而需要的修理等费用由申请人自行承担。
      </p>
      <p class="text-offset-1">三、其它</p>
      <p class="text-offset-2">
        1.服务发起后请您耐心等待，服务人员会在预约时间前与您联系。
      </p>
      <p class="text-offset-2">
        2.在我司涵盖的服务范围内无收费项目，所涉及收费均为代检技师个人行为，我公司对该行为不负责任。
      </p>
      <p class="text-offset-2">
        3. 服务期间若有任何意见或建议，可拨打我公司客服电话<a
          href="tel:4006995566"
        >4006995566</a>进行反映。
      </p>
      <p class="text-offset-2">
        4.在法律许可范围内，本公司保留对此项服务的解释权。
      </p>
      <p class="text-offset-1">特此函告。</p>
    </div>

    <div class="user-agreement-bottom">
      <div class="bottom-box">
        <div class="tips-text">
          <van-checkbox
            v-model="checked"
            shape="square"
            icon-size="18px"
            :disabled="disabled"
          >
            <span :style="{ color: disabled ? '' : 'rgb(47, 62, 236)' }">{{
              tipsText
            }}</span>
          </van-checkbox>
        </div>
        <van-button
          v-if="!checked"
          color="#E99D42"
          size="small"
          @click="goToNext"
          :disabled="disabled"
        >
          下一步
        </van-button>
        <div
          class="next-btn"
          v-if="checked"
        >
          <wx-open-launch-weapp
            id="user-launch-btn"
            username="gh_3e83e978db70"
            appid="wx1b080dca0cc84c55"
            :path="path"
            @launch="goToNext"
          >
            <script type="text/wxtag-template">
              <span style="font-size: 12px;line-height: 32px;font-weight:400;color:#FFF;">下一步</span>
            </script>
          </wx-open-launch-weapp>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  data() {
    return {
      checked: false,
      timer: null,
      timing: 3,
      path: '',
      productType: '',
      serviceType: '',
      titleMap: {
        FL70000001: '代为驾驶客户告知函',
        FL60000001: '代为送检服务客户告知函',
        FL10000001: '客户告知函',
        FL90000001: '客户告知函',
        FLA0000001: '客户告知函'
      }
    };
  },
  computed: {
    tipsText() {
      let text = '已阅读并同意';
      if (this.timing > 0) {
        text += `(${this.timing}s)`;
      }
      return text;
    },
    disabled() {
      return this.timing > 0;
    }
  },
  methods: {
    ...mapActions('wxsdk', ['wxSdkConfig']),

    _setInterval() {
      this.timer = setTimeout(() => {
        this.timing--;
        if (this.timing > 0) {
          this._setInterval();
        }
      }, 1000);
    },
    goToNext(e) {
      if (!this.checked) {
        this.$toast({
          message: '请勾选阅读并同意告知函',
          duration: 3000
        });
        return;
      }
      this.$router.back();
    }
  },
  mounted() {
    this.path = this.$route.query.path;
    this.timing = ~~this.$route.query.offset;
    this.productType = this.$route.query.productType;
    this.serviceType = this.$route.query.serviceType;
    this._setInterval();

    this.wxSdkConfig();
    document.getElementsByTagName('title')[0].innerText =
      this.titleMap[this.serviceType];
  }
};
</script>

<style lang="scss" scoped>
$indent: 20px;

.text-offset-0 {
  text-indent: $indent;
}

.text-offset-1 {
  margin-left: $indent;
}

.text-offset-2 {
  text-indent: $indent;
  margin-left: $indent;
}

.user-agreement {
  padding: 12px 12px 0 12px;
  background-color: #f5f5f5;

  &-content {
    font-size: 16px;
    line-height: 24px;
  }

  $bottomHeight: 40px;

  &-bottom {
    font-size: 14px;
    height: $bottomHeight;

    .bottom-box {
      position: fixed;
      bottom: 0;
      left: 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      height: $bottomHeight;
      line-height: $bottomHeight;
      padding: 0 15px;
      box-sizing: border-box;
      background-color: #e5e5e5;

      .tips-text {
      }

      .next-btn {
        width: 54px;
        height: 32px;
        line-height: 32px;
        background-color: #e99d42;
        color: white;
        text-align: center;
        border: none;
        border-radius: 2px;
        outline: none;
      }
    }
  }
}
</style>
